import { Box } from '@cast/design-system';
import { NetworkDailyDetailsTable } from '@cast/split-me/features/cluster/cost-report';
import { FailedToLoad } from '@cast/shared-messages-ui';

import { inventoryWorkloadTableKeys, tableCacheKeys } from '../../consts';

import { DateRangeUnsupportedBanner } from '../dashboard/_components/DateRangeUnsupportedBanner';
import { useInventoryWorkloadsTimeRangeSelection } from '../../_hooks/useInventoryWorkloadsTimeRangeSelection';
import { useInventoryWorkloadNetworkData } from './_hooks';

export const InventoryWorkloadListNetwork = () => {
  const { data, isLoading, error, isRangeSupported } =
    useInventoryWorkloadNetworkData();
  const { timeZone } = useInventoryWorkloadsTimeRangeSelection();

  if (!isRangeSupported) {
    return (
      <Box mt={24}>
        <DateRangeUnsupportedBanner testId="inventory-workload-network-unsupported-range" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box mt={24}>
        <FailedToLoad title="Failed to load workload network details" />
      </Box>
    );
  }

  return (
    <NetworkDailyDetailsTable
      chartData={data}
      isLoading={isLoading}
      timezone={timeZone}
      cacheKey={tableCacheKeys.INVENTORY_WORKLOAD.NETWORK}
      urlKey={inventoryWorkloadTableKeys.NETWORK}
      testId="inventory-workload-network-table"
    />
  );
};
